import axios from 'axios'
import router from '../router'; 
import { Message } from 'element-ui'
import { getRuntimeBaseUrl, switchToNextRuntimeServer } from './runtimeConfig'

const http = axios.create({
	timeout: 1000 * 30
})

const PUBLIC_API_PREFIXES = [
	'/system/config',
	'/login',
	'/register',
	'/captcha/',
	'/refreshToken'
]

const isPublicApi = (url = '') => PUBLIC_API_PREFIXES.some(prefix => String(url || '').startsWith(prefix))
const shouldHideErrorMessage = message => String(message || '').includes('系统繁忙')

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	config.baseURL = getRuntimeBaseUrl() || process.env.VUE_APP_BASE_API
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	
	
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken) {
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			exit();
		})
		// 保存token
		sessionStorage.setItem("accessToken", data.accessToken);
		sessionStorage.setItem("refreshToken", data.refreshToken);
		try {
			const oldLoginInfo = JSON.parse(localStorage.getItem('loginInfo') || '{}')
			localStorage.setItem('loginInfo', JSON.stringify({
				...oldLoginInfo,
				...data,
				imAccid: data.imAccid || oldLoginInfo.imAccid,
				imToken: data.imToken || oldLoginInfo.imToken
			}))
		} catch (error) {
			console.warn('[httpRequest] 刷新 token 时更新登录缓存失败:', error)
		}
		// 重新发送刚才的请求
		return http(response.config)
	} else {
		if (!shouldHideErrorMessage(response.data.message)) {
			Message({
				message: response.data.message,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
		}
		return Promise.reject(response.data)
	}
}, async error => {
	const config = error.config || {}
	const method = String(config.method || 'get').toUpperCase()
	const canFailover = method === 'GET' && !config.__runtimeFailoverRetried
	if (canFailover) {
		const nextBaseUrl = switchToNextRuntimeServer(config.baseURL)
		if (nextBaseUrl) {
			config.__runtimeFailoverRetried = true
			config.baseURL = nextBaseUrl
			return http(config)
		}
	}

	if (!error.response) {
		return Promise.reject(error)
	}

	if (isPublicApi(config.url)) {
		return Promise.reject(error)
	}

	switch (error.response.status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			exit();
			break
		case 405:
			Message({
				message: 'http请求方式有误',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: '服务器出了点小差，请稍后再试',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: '服务器不支持当前请求所需要的某个功能',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}

	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
